import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { trackPageView } from "utils/azureAppI";

const useTrackPageViews = () => {
    const location = useLocation();
    const appInsightsPlugin = useContext(AppInsightsContext);
    useEffect(() => {
        trackPageView({ name: location.pathname });
    }, [location, appInsightsPlugin]);
};

export default useTrackPageViews;
